let $tables;
const $ = jQuery;

const build_responsive_grid_table = (selector) => {
  $tables = $(selector);

  if ($tables.length < 1) return;

  $tables.each(function () {
    const $table = $(this);

    if (!$table.hasClass('table--responsive')) {
      $table.addClass('table--responsive');

      const headers = $table.find('thead th').map((i, v) => {
        return v.innerText;
      });

      $table.find('tbody tr').each(function (i, v) {
        $(this).find('th,td').each(function (p, q) {
          const $cell = $(this);
          if ($cell.is('td') && headers.length > 0) {
            $cell.prepend('<div class="responsive-label">' + headers[p] + '</div>');
          }
        });
      });
    }
  });

};

let resizeTimer;

const forceResponsive = () => {
  $tables.each(function () {
    let $this = $(this);
    $this.removeClass('force-responsive');

    if ($this.outerWidth() > $this.parent().outerWidth()) {
      $this.addClass('force-responsive');
    }

  });
}

const responsive_grid_table = (selector = 'table') => {
  $(document).ready(function () {
    build_responsive_grid_table(selector);
    forceResponsive();
  });

  $(window).on('resize', function (e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {

      forceResponsive();

    }, 100);

  });
}


window.responsive_grid_table = responsive_grid_table;